import { Box } from "@mui/material";
import { Color, DotLegalChip } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../localization/useTranslation";
import MentionInputRender from "./mentionInput/MentionInputRender.tsx";

export interface SubTaskCountChipProps {
    subTasks: Array<string>;
    index: number;
}

function SubTaskCountChip(props: SubTaskCountChipProps) {
    const { translateString } = useTranslation();

    function getSubTaskHover(subTasks: Array<string>, rowIndex: number) {
        return (
            <React.Fragment>
                <Box sx={{ margin: 1.5 }}>{translateString("subTasks")}:</Box>
                {subTasks.map((x, index) => (
                    <Box sx={{ margin: 1.5 }} key={rowIndex + "subtasks" + index}>
                        <MentionInputRender value={x} />
                    </Box>
                ))}
            </React.Fragment>
        );
    }

    const taskTranslation = props.subTasks.length === 1 ? translateString("task") : translateString("tasks");

    return props.subTasks.length > 0 ? (
        <DotLegalChip
            key={""}
            value={`${props.subTasks.length} ${taskTranslation.toLowerCase()}`}
            size={"small"}
            color={Color.lightBlue}
            variant={"outlined"}
            hoverText={props.subTasks.length > 0 ? getSubTaskHover(props.subTasks, props.index) : ""}
        />
    ) : undefined;
}

export default SubTaskCountChip;
